<template>
  <path
    d="M5.71 15.7102L10.29 20.2902C10.68 20.6802 11.32 20.6802 11.71 20.2902C12.1 19.9002 12.1 19.2602 11.71 18.8702L8.83 16.0002H19C19.55 16.0002 20 15.5502 20 15.0002V5.00024C20 4.45024 19.55 4.00024 19 4.00024C18.45 4.00024 18 4.45024 18 5.00024V14.0002H8.83L11.71 11.1302C12.1 10.7402 12.1 10.1002 11.71 9.71024C11.32 9.32024 10.68 9.32024 10.29 9.71024L5.71 14.2902C5.32 14.6802 5.32 15.3202 5.71 15.7102Z"
  />
</template>
